import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Смена статуса",
    loading: _ctx.state.is_loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_file_reader, {
        accept: "application/pdf",
        placeholder: "Скан/Копия ЭК",
        value: _ctx.state.file,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.file) = $event)),
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.file.$error,
        "validation-errors": _ctx.state_form$.file.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}